import styled from 'styled-components';
import Table from '../../../Table';

const StyledTransactionsTable = styled(Table)`
  &.collapsed {
    .card-number {
      display: none;
    }
  }

  .transaction-type {
    align-items: center;
    display: flex;

    svg {
      height: 24px;
      width: 24px;

      path:not([fill-rule="evenodd"]) {
        fill: ${props => props.theme.colors.neutral_6};
      }
    }
  }

  .transaction-icon {
    display: inline-flex;
    svg {
      height: 16px;
      width: 16px;

      path {
        &:not([fill-rule="evenodd"]) {
          fill: ${props => props.theme.colors.neutral_6};
        }
      }
    }
  }

  .returned-price {
    color: ${props => props.theme.colors.neutral_7};
    text-decoration: line-through;
  }
`;

export {
  StyledTransactionsTable,
};
